import styled from "@emotion/styled";
import { useDeepCompareMemo } from "@react-hookz/web";

import type { ContentSchemaRenderProps } from "~/components/content/content-schema-render";

import type { ExtraProps } from ".";
import { InlineWidget as ContentSchemaRenderInlineWidget } from ".";

const getRenderInlineWidgetComponent = (extraProps: ExtraProps) => {
  const Component = (p: ContentSchemaRenderProps) => (
    <ContentSchemaRenderInlineWidget {...p} {...extraProps} />
  );
  return styled(Component)``;
};

export function useContentSchemaRenderInlineWidget(extraProps: ExtraProps) {
  const ComponentWithExtraProps = useDeepCompareMemo(
    () => getRenderInlineWidgetComponent(extraProps),
    [extraProps],
  );

  return {
    ComponentWithExtraProps,
  };
}
